import { ReactNode } from 'react';
import styles from './AISCard.module.scss';

interface infoWrapperI {
  label?: string | ReactNode;
  title?: string;
  value?: string | number | ReactNode;
  strong?: boolean;
  borderBottom?: boolean;
  valueIcon?: ReactNode;
  labelIcon?: ReactNode;
  clickable?: boolean;
  onClick?: () => void;
  dots?: boolean;
}
export const InfoWrapper = ({
  label,
  title,
  value,
  strong = false,
  dots = true,
  borderBottom,
  labelIcon,
  valueIcon,
  clickable,
  onClick,
}: infoWrapperI) => {
  const getValue = () => {
    if (typeof value === 'string' || typeof value === 'number') {
      return (
        <div className={styles.value} data-click={clickable}>
          {strong && <strong>{value}</strong>}
          {!strong && value}
          {valueIcon}
        </div>
      );
    }
    if (value === null || typeof value === undefined) {
      return <div className={styles.no_data}>&mdash;</div>;
    }
    return (
      <div className={styles.value} data-click={clickable} data-title={value}>
        {value}
      </div>
    );
  };
  const info = (
    <>
      {label !== 'undefined' && (
        <>
          <div className={styles.label}>
            {labelIcon && <span className={styles.label_icon}>{labelIcon}</span>}
            {label}
          </div>
          {dots && <div className={styles.dots} />}
        </>
      )}
      {getValue()}
    </>
  );

  return (
    <div
      title={title}
      className={styles.info_wrapper}
      data-value={value !== null && typeof value !== 'undefined'}
      data-border={borderBottom}
      data-click={clickable}
      onClick={() => (clickable && onClick ? onClick() : null)}
    >
      {info}
    </div>
  );
};
